module.exports = __webpack_public_path__ + "img/UAE-landscape-english-portrait.6e5b8d77.png";